import React from 'react';
import { isEmpty } from 'lodash/fp';
import { routes } from 'constants/config';
import filterSuggestions from 'utils/filterSuggestions';
import { useToggle } from 'hooks';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import ContentLearningLibrary from 'components/shared/ContentLearningLibrary';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import { useContainerVisibilityGroups } from 'components/OnDemandPractice/hooks';

const GroupListingVisibility = ({ scenario }) => {
  const {
    conversation = {},
    containerVisibilityGroups,
    id,
    prompt,
    scenarioType,
  } = scenario;
  const { customerName, interactions } = conversation;
  const [editing, toggleEditing] = useToggle();
  const visibilityGroups = useContainerVisibilityGroups({
    initialState: containerVisibilityGroups,
    scenarioId: id,
  });

  const showErrorMessage =
    scenarioType === 'conversation' &&
    (!customerName ||
      !prompt ||
      !!interactions.some(
        int =>
          !int.subject || int.responses.some(res => !res.text && !res.subject),
      ));

  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          <span className="mr-4">
            {t('practice.on_demand_practice.overview.visibility.header')}
          </span>
          <InfoTooltip
            tooltip={t(
              'practice.on_demand_practice.overview.visibility.tooltip',
            )}
          />
        </span>
        {!editing && !isEmpty(visibilityGroups.data) && (
          <button
            type="button"
            className="u-linkBtn fz-base fw-n"
            onClick={toggleEditing}
          >
            <Icon name="edit" className="mr-4" />
            {t('common.edit')}
          </button>
        )}
      </SectionHeader>
      <ContentLearningLibrary
        advanced
        disabled={showErrorMessage}
        editing={editing}
        onCreateContent={visibilityGroups.create}
        onRemoveContent={visibilityGroups.remove}
        toggleEditing={toggleEditing}
        libraryContents={visibilityGroups.data}
        emptyStateActionText={t(
          'practice.on_demand_practice.overview.visibility.add_to_odp',
        )}
        removeTooltip={t(
          'practice.on_demand_practice.overview.visibility.remove_group',
        )}
        suggestionsProps={{
          url: routes.GROUPS,
          mapResponseToSuggestions: response => response.groups,
          filterSuggestions: filterSuggestions(
            visibilityGroups.data,
            'group.id',
          ),
          queryParam: 'q',
        }}
      />
      {showErrorMessage && !containerVisibilityGroups.length && (
        <div className="bg-gray-lightest fz-12 c-gray-darker d-f p-4">
          <Icon name="warning_sign" className="m-4 mr-8 is-14" />
          <span className="fz-12 c-gray-darker">
            {t(
              'practice.on_demand_practice.overview.visibility.incomplete_warning',
            )}
          </span>
        </div>
      )}
    </Section>
  );
};

export default GroupListingVisibility;
